// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","HasSeenAd":"cm_a bhc_fg bhc_up bhc_vz bhc_h"};